import { render, staticRenderFns } from "./ShortArea.vue?vue&type=template&id=12f33b30&scoped=true&"
import script from "./ShortArea.vue?vue&type=script&lang=js&"
export * from "./ShortArea.vue?vue&type=script&lang=js&"
import style0 from "./ShortArea.vue?vue&type=style&index=0&id=12f33b30&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12f33b30",
  null
  
)

export default component.exports